import { Button, CustomIconName, Status, StatusState, StatusVariant, theme } from '@ketch-com/deck'
import { PermitTransactionV2OrchestrationsResultDTO } from '@ketch-com/figurehead'
import { Tooltip, Typography } from '@mui/material'
import React from 'react'

export enum PermitResult {
  Orchestrated = PermitTransactionV2OrchestrationsResultDTO.OrchestratedPermitTransactionV2OrchestrationsResult,
  InsufficientIds = PermitTransactionV2OrchestrationsResultDTO.InsufficientIdentifiersPermitTransactionV2OrchestrationsResult,
  Disabled = PermitTransactionV2OrchestrationsResultDTO.DisabledPermitTransactionV2OrchestrationsResult,
  Other = PermitTransactionV2OrchestrationsResultDTO.OtherPermitTransactionV2OrchestrationsResult,
}

interface PermitResultStatusProps {
  result?: PermitTransactionV2OrchestrationsResultDTO
}

const PermitResultStatusState: Record<PermitTransactionV2OrchestrationsResultDTO, StatusState> = {
  [PermitResult.Orchestrated]: StatusState.success,
  [PermitResult.InsufficientIds]: StatusState.draft,
  [PermitResult.Disabled]: StatusState.error,
  [PermitResult.Other]: StatusState.draft,
}

const PermitResultStatusLabel: Record<PermitTransactionV2OrchestrationsResultDTO, string> = {
  [PermitResult.Orchestrated]: 'Orchestrated',
  [PermitResult.InsufficientIds]: 'Missing Identifier',
  [PermitResult.Disabled]: 'Disabled',
  [PermitResult.Other]: 'Other',
}

const PermitResultStatusIcon: Record<PermitTransactionV2OrchestrationsResultDTO, CustomIconName> = {
  [PermitResult.Orchestrated]: 'OCheck',
  [PermitResult.InsufficientIds]: 'ODecline',
  [PermitResult.Disabled]: 'OCross',
  [PermitResult.Other]: 'OCross',
}

export const PermitResultStatus: React.FC<PermitResultStatusProps> = ({ result = PermitResult.Other }) => {
  return (
    <Tooltip
      title={
        result === PermitResult.Other ? (
          <>
            There was an issue orchestrating to this connection. Please review it for errors first, and then contact{' '}
            <Button variant="link" onClick={() => window.open('mailto:support@ketch.com')}>
              <Typography color={theme.palette.White.o100} variant="smallBody" sx={{ textDecoration: 'underline' }}>
                support@ketch.com
              </Typography>
            </Button>{' '}
            or your customer experience representative.
          </>
        ) : null
      }
      placement="bottom"
    >
      <span>
        <Status
          variant={StatusVariant.filled}
          status={PermitResultStatusState[result]}
          label={PermitResultStatusLabel[result]}
          icon={PermitResultStatusIcon[result]}
        />
      </span>
    </Tooltip>
  )
}
